module.exports = "/_next/static/images/collaborate@2x-7bacdb909036b6c0d1640f88178d47a0.png";